import { PrimaryButton } from '@/srp/Button';
import ClickableTile from '@/srp/SearchResults/ClickableTile';
import { SELL_MY_CAR_URL } from '~/constants/srp';
import CarIcon from '~/icons/srp/CarIcon';

export default function TradeYourCarTile() {
  return (
    <ClickableTile
      link={SELL_MY_CAR_URL}
      tileId="tradetile"
      name="TradeinTile"
      nativeAction="view-trade-offer"
      analyticsId="Trade-in Tile"
    >
      <div className="gap-16 grid justify-items-center py-12 text-blue-6 text-center w-[290px]">
        <CarIcon />
        <p className="tl-brand-s">
          Trade in your car
          <br />
          with carvana
        </p>
        <PrimaryButton size="small" className="w-[260px]">
          Get your offer
        </PrimaryButton>
      </div>
    </ClickableTile>
  );
}
